<template>
  <validation-observer ref="obs">
    <v-container
      v-show="!emailSent"
      id="login"
      class="fill-height"
      tag="section"
    >
      <v-row justify="center">
        <v-slide-y-transition appear>
          <base-material-card
            color="success"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  Forgot Password
                </h1>
              </div>
            </template>

            <v-card-text class="text-center">
              <validation-provider
                name="email"
                rules="required|email"
              >
                <v-text-field
                  v-model="form.email"
                  slot-scope="{errors,valid }"
                  color="secondary"
                  label="Email..."
                  :error-messages="errors"
                  :success="valid"
                  prepend-icon="mdi-email"
                />
              </validation-provider>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <pages-btn
                small
                color="success"
                :loading="resetLoader"
                :disabled="resetLoader"
                @click="requestResetPassword"
              >
                Send Password Reset Link
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </pages-btn>
            </v-card-actions>
          </base-material-card>
        </v-slide-y-transition>
      </v-row>
    </v-container>
    <v-container
      v-show="emailSent"
      class="fill-height"
      tag="section"
    >
      <v-row justify="center">
        <h1
          align-center
          justify-center
          m0-auto
        >
          Reset link has been sent to the mail provided
        </h1>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :color="colorValue"
    >
      {{ text }}
    </v-snackbar>
  </validation-observer>
</template>

<script>
  import { _forgotPassword } from '@/services/Auth'

  import {
    ValidationObserver,
    ValidationProvider,
  //  withValidation
  } from 'vee-validate'

  export default {
    name: 'ForgotPassword',
    inject: ['$validator'],
    components: {
      ValidationProvider,
      ValidationObserver,
      PagesBtn: () => import('./components/Btn'),
    },
    data: () => ({
      form: {
        email: '',
      },
      emailSent: false,
      resetLoader: false,
      snackbar: false,
      text: '',
      timeout: 5000,
      colorValue: '',
    }),
    mounted () {
      if (this.$store.state.user.isLoggedIn && this.$store.state.user.role === 'ADMIN') {
        this.$router.push('admin/users')
      } else if (this.$store.state.user.isLoggedIn && this.$store.state.user.role === 'USER') {
        this.$router.push('/dashboard')
      }
    },

    methods: {

      async requestResetPassword () {
        const result = await this.$refs.obs.validate()
        if (result) {
          this.resetLoader = true
          _forgotPassword(this.form).then(
            response => {
              this.snackbar = true
              this.text = response.data.message
              this.resetLoader = false
              if (response.data.success) {
                this.colorValue = 'success'
                this.emailSent = true
              } else {
                this.colorValue = 'error'
              }
            },
            error => {
              this.snackbar = true
              this.colorValue = 'red'
              this.text = error.data.message
              this.resetLoader = false
            }
          )
        }
      },

    },

  }

</script>

<style lang="css">
  .h40 {
    height: 40px
  }

  .v-expansion-panel {
    background-color: orange
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

</style>
